import * as React from "react";
import Box from "@mui/material/Box";
import { SxProps, Theme } from "@mui/material";
import Italic01SVG from "./svg/italic-01.svg?react";

// THIS FILE IS AUTOMATICALLY GENERATED BY A SCRIPT
// PLEASE DO NOT MANUALLY EDIT IT.
// The script can be found in /scripts/convertSVGsToIcons.js

export type IconProps = React.RefAttributes<HTMLSpanElement> & React.HTMLAttributes<HTMLSpanElement> & {
  /** size of the icon and container. if you want the container to be differently sized, use height/width in the sx prop */
  size?: number;
  /** color of the icon -- this will apply to anywhere in the svg files that the currentColor keyword is used */
  color?: string;
  /** fill color of the icon -- this will override the default fill property, if present, in the svg. you don't need this for most cases. */
  fill?: string;
  /** stroke color of the icon -- this will override the default stroke property, if present, in the svg. you don't need this for most cases. */
  stroke?: string;
  /** stroke width of the icon -- this will override the default stroke-width property, if present, in the svg. you don't need this for most cases. */
  strokeWidth?: number;
  className?: string;
  /** sx prop for the icon container */
  sx?: SxProps<Theme>;
};

function Italic01IconInner(
  props: IconProps,
  ref: React.ForwardedRef<HTMLSpanElement>
) {
  const { size = 24, color, fill, stroke, strokeWidth = 2, className, sx = {}, ...htmlProps } = props;
  return (
    <Box component="span" className={className} ref={ref} sx={{ height: size, width: size, color, display: 'inline-block', overflow: 'hidden', flexShrink: 0, userSelect: 'none', textAlign: 'center', ...sx }} {...htmlProps}>
      <Italic01SVG height={`${size}px`} width={`${size}px`} style={{ fill, stroke, strokeWidth }} />
    </Box>
  );
}

export const Italic01Icon = React.forwardRef<HTMLSpanElement, IconProps>(
  Italic01IconInner
);
